import { SxProps, Theme } from "@mui/material";

export const recordingPulseAnimation = {
  animate: { scale: [1, 1.1, 1] },
  transition: { repeat: Infinity, duration: 1 },
};

export const fieldWrapperStyle: SxProps<Theme> = {
  position: "relative",
  overflow: "visible",
};

export const getTextFieldStyle = (
  theme: Theme,
  options: {
    showVoiceButton: boolean;
    isAnswerChecked: boolean;
    hasValue: boolean;
    points: number | null;
    hasError?: boolean;
  },
): SxProps<Theme> => ({
  overflow: "visible",
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.palette.quizPopap.quizSelector,
    color: theme.palette.quizPopap.quizSelectorText,
    overflow: "visible",
    alignItems: "flex-end",
    pr: options.showVoiceButton ? 7 : undefined,
    pb: options.showVoiceButton ? 7 : undefined,
    "& fieldset": {
      borderColor: options.hasError
        ? "#DD503E"
        : options.isAnswerChecked
          ? "transparent"
          : options.hasValue
            ? "#06B6D4"
            : theme.palette.quizPopap.quizSeparator,
    },
    "&:hover fieldset": {
      borderColor: options.hasError ? "#DD503E" : "#06B6D4",
    },
    "&.Mui-focused fieldset": {
      borderColor: options.hasError ? "#DD503E" : "#06B6D4",
    },
    "&.Mui-disabled": {
      backgroundColor: options.isAnswerChecked
        ? options.points !== null && options.points > 0
          ? "#66EF64B2"
          : options.points === 0
            ? "#DD503E"
            : theme.palette.quizPopap.quizSelector
        : theme.palette.quizPopap.quizSelector,
      color: options.isAnswerChecked && options.points === 0 ? "#FFFFFF" : "inherit",
    },
  },
});

export const voiceButtonContainerStyle: SxProps<Theme> = {
  position: "absolute",
  right: 14,
  bottom: 14,
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
  "& .MuiIconButton-root": {
    pointerEvents: "auto",
  },
};

export const voicePreviewContainerStyle: SxProps<Theme> = {
  position: "absolute",
  left: 12,
  right: 58,
  bottom: 14,
  zIndex: 1,
  minWidth: 0,
  "& > *": {
    width: "100%",
  },
};

export const getVoiceButtonStyle = (
  isRecording: boolean,
  isTranscribing = false,
): SxProps<Theme> => ({
  background: isRecording
    ? "linear-gradient(135deg, #FF3B30 0%, #D70015 100%)"
    : "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
  color: "#ffffff",
  width: 36,
  height: 36,
  minWidth: 36,
  minHeight: 36,
  p: 0,
  flexShrink: 0,
  overflow: "visible",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  transition: "background 0.2s ease, opacity 0.2s ease",
  "&:hover": {
    background: isRecording
      ? "linear-gradient(135deg, #E6352B 0%, #C40012 100%)"
      : "linear-gradient(180deg, #20B6C8 0%, #7C4ABF 100%)",
    opacity: isTranscribing ? 0.55 : 0.95,
  },
  "&.Mui-disabled": {
    background: isTranscribing
      ? "linear-gradient(180deg, #94A3B8 0%, #64748B 100%)"
      : "linear-gradient(180deg, #28C9DC 0%, #7B49C1 100%)",
    opacity: isTranscribing ? 0.9 : 0.7,
    color: "#ffffff",
  },
  "& svg": {
    width: 20,
    height: 20,
    display: "block",
    flexShrink: 0,
  },
});

export const transcribingProgressStyle: SxProps<Theme> = {
  color: "#ffffff",
};

export const hintTextStyle = (theme: Theme): SxProps<Theme> => ({
  mt: 1,
  display: "block",
  color: theme.palette.quizPopap.quizSelectorText,
  fontSize: "12px",
  opacity: 0.7,
  fontStyle: "italic",
});

export const validationErrorInsideStyle: SxProps<Theme> = {
  position: "absolute",
  left: 14,
  right: 58,
  bottom: 14,
  zIndex: 1,
  color: "#DD503E",
  fontSize: "13px",
  lineHeight: 1.35,
  fontWeight: 500,
  pointerEvents: "none",
};
